import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { IconButton } from 'react-toolbox';
import moment from 'moment';
import { can } from '../../../../../../services';
import { syncPhaseImsStatus, pollPhaseImsStatus } from 'actionCreators';
import { momentDiff } from '../../../../../../utils/dateUtils.js';
import S from './phaseTaskBar.scss';
import PhaseType from 'types/phase';

const SYNC_COOLDOWN_MINUTES = 15;
const SYNC_POLL_MS = 5000;
const SYNC_TIMEOUT_MS = 60000;

const formatStatusLastUpdated = date => (date ? moment(date).format('MM/DD/YYYY, h:mm A (Z)') : '--');

class ImsStatus extends React.Component {
  state = { now: Date.now(), syncing: false };

  componentDidMount = () => {
    this.interval = setInterval(() => this.setState({ now: Date.now() }), 30000);
  };

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.phase.status_last_updated !== this.props.phase.status_last_updated) {
      this.stopSyncPoll();
      this.setState({ syncing: false });
    }
  };

  componentWillUnmount = () => {
    clearInterval(this.interval);
    this.stopSyncPoll();
  };

  minutesSinceLastSync = () => {
    const { phase: { status_last_updated } } = this.props;
    return status_last_updated ? momentDiff(this.state.now, status_last_updated, 'minutes') : null;
  };

  canSync = () => {
    const minutesSince = this.minutesSinceLastSync();
    return !this.state.syncing && (minutesSince === null || minutesSince >= SYNC_COOLDOWN_MINUTES);
  };

  formatStatusName = status => (status ? status.replace(/_/g, ' ') : '--');

  formatWoContextName = (context) => {
    if (!context) return '--';
    if (context === 'EXECUTION_PHASE') return 'Repair';
    return 'Assessment';
  };

  handleSync = () => {
    const { phase, syncPhaseImsStatus: sync } = this.props;
    if (!this.canSync()) return;
    this.setState({ syncing: true });
    sync(phase.id);
    this.startSyncPoll();
  };

  startSyncPoll = () => {
    if (this.syncPoll) return;
    this.syncPoll = setInterval(
      () => this.props.pollPhaseImsStatus(this.props.phase.id),
      SYNC_POLL_MS,
    );
    this.syncTimeout = setTimeout(this.handleSyncTimeout, SYNC_TIMEOUT_MS);
  };

  stopSyncPoll = () => {
    clearInterval(this.syncPoll);
    this.syncPoll = null;
    clearTimeout(this.syncTimeout);
    this.syncTimeout = null;
  };

  handleSyncTimeout = () => {
    this.stopSyncPoll();
    this.setState({ syncing: false });
  };

  render = () => {
    const { phase, role } = this.props;
    return (<div className={S.phaseTaskBar__imsStatus}>
      <h5>Vendor Gateway Status</h5>
      <span className={S.phaseTaskBar__imsStatusRow}>
        <span
          className={S.statusText}
          title={`Last updated: ${formatStatusLastUpdated(phase.status_last_updated)}`}
        >
          {this.formatStatusName(phase.ims_status)}
          {phase.type === 'Workorder' && ` (${this.formatWoContextName(phase.wo_context)})`}
        </span>
        {can(role, 'update_ims_status', 'phase') && <IconButton
          icon="autorenew"
          className={classNames(S.imsSyncIcon, { [S.imsSyncIconSpinning]: this.state.syncing })}
          disabled={!this.canSync()}
          onClick={this.handleSync}
          title="Sync IMS Status"
        />}
      </span>
    </div>);
  }
}

ImsStatus.propTypes = {
  phase: PhaseType.isRequired,
  role: PropTypes.string.isRequired,
  syncPhaseImsStatus: PropTypes.func.isRequired,
  pollPhaseImsStatus: PropTypes.func.isRequired,
};

export default connect(null, { syncPhaseImsStatus, pollPhaseImsStatus })(ImsStatus);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/imsStatus.jsx